import type { VendorData } from './dashboard';

const PARTNER_FORBIDDEN_KEYS = new Set([
  'orderKey',
  'itemKey',
  'offer_bk',
  'offerBk',
  'vendor_bk',
  'margin_aud',
  'luxplus_member_flag',
  'pcmName',
  'sales',
  'views',
  'history',
]);

/** Refuse partner exports that carry internal source keys anywhere in the vendor aggregates. */
export function assertPartnerSafe(data: unknown) {
  const verify = (value: unknown) => {
    if (!value || typeof value !== 'object') {
      return;
    }
    for (const [key, item] of Object.entries(value)) {
      if (PARTNER_FORBIDDEN_KEYS.has(key)) {
        throw Error('Partner export contains internal source data.');
      }
      verify(item);
    }
  };
  verify(data);
}

/** Build the isolated partner document from vendor aggregates, never from Admin DOM. */
export async function partnerHtml(data: VendorData, settings: Record<string, unknown>) {
  const { partnerScript, partnerStyle } = await import('./partnerBundle');
  assertPartnerSafe(data);
  const safeJson = (value: unknown) =>
    JSON.stringify(value).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');
  const attr = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  return (
    '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' +
    attr(data.property) +
    ' · Flash Campaign Report</title><style>body{margin:0;background:#F9F7F1}' +
    partnerStyle +
    '</style></head><body><div id="root" data-flash-settings="' +
    attr(JSON.stringify(settings)) +
    '"></div><script id="flash-vendor-data" type="application/json">' +
    safeJson(data) +
    '</script><script>' +
    partnerScript.replace(/<\/script/gi, '<\\/script') +
    '</script></body></html>'
  );
}
export async function downloadPartnerReport(
  data: VendorData,
  settings: Record<string, unknown>,
  assertCurrent: () => void = () => {},
) {
  assertCurrent();
  const html = await partnerHtml(data, settings);
  assertCurrent();
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Flash-Campaign-Report.html';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
